module.exports = __webpack_public_path__ + "static/media/apple-touch-startup-image-2048x2732.8befab8b.png";